import 'css-chunk:src/applications/ReportsApp/components/Metric/Metric.module.scss';export default {
  "statistic": "_statistic_id7l6_1",
  "trend": "_trend_id7l6_20",
  "blue": "_blue_id7l6_35",
  "plum": "_plum_id7l6_45",
  "orange": "_orange_id7l6_55",
  "green": "_green_id7l6_65"
};